export enum KONTOMATIK_INTEGRATION_MODE {
  EMBEDDED_WIDGET = "EMBEDDED_WIDGET",
  SIGNIN_REDIRECTION = "SIGNIN_REDIRECTION",
}

const blockedInAppBrowsersRegexp = /(FBAN|FBAV|FB_IAB|FB4A|Instagram|InstagramWebView|Line|wv|WebView|Messenger)/i;
const instagramReferrerRegexp = /(^|\.)instagram\.com$/i;
const instagramSourceHintRegexp = /(instagram|ig|meta)/i;

const isInstagramTraffic = (): boolean => {
  const userAgent = window.navigator.userAgent ?? "";
  if (/Instagram/i.test(userAgent)) {
    return true;
  }

  try {
    const params = new URLSearchParams(window.location.search);
    const sourceHints = [
      params.get("utm_source"),
      params.get("source"),
      params.get("utm_medium"),
    ]
      .filter((v): v is string => !!v)
      .join(" ")
      .toLowerCase();

    if (instagramSourceHintRegexp.test(sourceHints)) {
      return true;
    }
  } catch {
    // ignore
  }

  const referrer = document.referrer ?? "";
  if (!referrer) {
    return false;
  }

  try {
    const referrerHost = new URL(referrer).hostname;
    return instagramReferrerRegexp.test(referrerHost);
  } catch {
    return false;
  }
};

const supportsRequiredBrowserFeatures = (): boolean => {
  const hasCssApi = typeof window.CSS !== "undefined" && typeof window.CSS.supports === "function";
  if (!hasCssApi) {
    return false;
  }

  const supportsGrid = window.CSS.supports("display", "grid");
  const supportsCssVariables = window.CSS.supports("--test-variable", "0");

  return supportsGrid && supportsCssVariables;
};

const isBlockedInAppBrowser = (): boolean => {
  const userAgent = window.navigator.userAgent ?? "";
  return blockedInAppBrowsersRegexp.test(userAgent) || isInstagramTraffic();
};

export const detectKontomatikIntegrationMode = (): KONTOMATIK_INTEGRATION_MODE => {
  if (!supportsRequiredBrowserFeatures()) {
    return KONTOMATIK_INTEGRATION_MODE.SIGNIN_REDIRECTION;
  }

  if (isBlockedInAppBrowser()) {
    return KONTOMATIK_INTEGRATION_MODE.SIGNIN_REDIRECTION;
  }

  return KONTOMATIK_INTEGRATION_MODE.EMBEDDED_WIDGET;
};
